import { Box, Card, List, ListItem, ListItemSecondaryAction, ListItemText, Typography } from '@material-ui/core';
import React from 'react';
import Currency from '../../../commonModules/Currency';
import { reconciledAmount } from '../../../../../../jsx/utils/factId5000';
import { useCurrency } from '../../../../../../jsx/hooks/useCurrency';

// Composant fonctionnel — il n'a pas d'état, et la devise du compte n'est accessible
// que par un hook.
function SpendingDetails({ spending }) {
    // Les montants sont stockés dans la devise du compte : sans cette indication, Currency
    // les libellerait en FCFA, ce qui est faux pour les comptes en Euro ou en dollar.
    const currency = useCurrency() || 'FCFA';
    // Montant déjà rapproché avec des achats ou réapprovisionnements externes 8000.
    const pointed = reconciledAmount(spending.spending_amount, spending.spending_rest_to_match);

    return (
                <Card >
                    <Box p={1}>
                        <List>                                      
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography variant="h6">Reste à pointer:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        color="secondary"
                                        primary={
                                            <Typography color="secondary" variant="subtitle1">
                                                <Currency value={spending.spending_rest_to_match} sourceCurrency={currency} />
                                            </Typography>
                                        }
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>  
                            {pointed !== null &&
                                <ListItem>
                                    <ListItemText
                                        primary={
                                            <Typography>Montant pointé:</Typography>
                                        }
                                    />
                                    <ListItemSecondaryAction>
                                        <ListItemText
                                            primary={
                                                <Typography variant="subtitle1">
                                                    <Currency value={pointed} sourceCurrency={currency} />
                                                </Typography>
                                            }
                                        />
                                    </ListItemSecondaryAction>
                                </ListItem>
                            }
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography >Montant total:</Typography>
                                    }
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText
                                        color="secondary"
                                        primary={
                                            <Typography variant="subtitle1">
                                                <Currency value={spending.spending_amount} sourceCurrency={currency} />
                                            </Typography>
                                        }
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Date encaissement:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        primary={new Date(spending.spending_date).toLocaleDateString("fr-FR")}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Banque:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={spending.spending_bank} />
                                </ListItemSecondaryAction>
                            </ListItem>
                            {/* <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Poste:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={spending.spending_post} />
                                </ListItemSecondaryAction>
                            </ListItem> */}
                            {/* <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Référence:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={spending.spending_ref} />
                                </ListItemSecondaryAction>
                            </ListItem> */}
                            {/* <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Description:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={spending.spending_desc} />
                                </ListItemSecondaryAction>
                            </ListItem> */}
                        </List>
                        <Box p={1}>
                            <Typography variant="caption">{spending.spending_desc}</Typography>
                        </Box>
                    </Box>
                </Card>
    );
}

export default SpendingDetails;